








import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class VideoPopup extends Vue {
    @Prop()
    protected videoUrl!: string;

    @Prop()
    protected title!: string;

    private close() {
        this.$emit('close');
    }
}
